<template>
<div class="product-list-box">
  <div
    class="fixed-visa-form-name"
    v-if="layout.visaFormName"
  >{{ layout.visaFormName }}</div>
  <!-- 商品列表  -->
  <div v-if="productList.length">
    <!-- 推荐列表 -->
    <div class="recommend-product-list" v-if="recommendProductList.length">
      <div class="recommed-title">
        <div class="text">热门推荐</div>
      </div>
      <div class="product-list">
        <product-item
          v-for="item in recommendProductList"
          :key="item.visa_product_id"
          :countryInfo="countryInfo"
          :product="item"
          :province-code="provinceCode"
        ></product-item>
      </div>
    </div>

    <!-- 其他 -->
    <div>
      <!-- 显示分类名称 -->
      <div v-if="showVisaTypeCategoryName">
        <div class="category-product-list" 
          v-for="(value, key) in categoryProductObj" 
          :key="key" 
          :name="key"
          ref="categoryProductList"
        >
          <div class="category-title">{{ key }}</div>
          <div class="product-list">
            <product-item
              v-for="item in value"
              :key="item.visa_product_id"
              :countryInfo="countryInfo"
              :product="item"
              :province-code="provinceCode"
            ></product-item>
          </div>
        </div>
      </div>

      <!-- 直接显示----非综合排序 -->
      <div :class="['product-list', recommendProductList.length && showProductList.length ? 'm-t-12' : '' ]" v-else>
        <product-item
          v-for="item in showProductList"
          :key="item.visa_product_id"
          :countryInfo="countryInfo"
          :product="item"
          :province-code="provinceCode"
        ></product-item>
      </div>
    </div>
    
  </div>

  <div class="nodata" v-else>
    <img class="nodata-img" src="../../../assets/imgs/product-detail/nodata-product.png" alt="">
    <div class="nodata-text">暂无数据</div>
  </div>
</div>
</template>

<script>
import ProductItem from './product-item.vue';
import utils from '@/libs/utils';
import CountryFilter from './country-filter.vue';

export default {
  name: '',
  components: {
    ProductItem,
    CountryFilter,
  },
  props: {
    countryInfo: Object,
    productList: {
      type: Array,
      default() {
        return [];
      },
    },
    provinceCode: Number,
    entryCountType: Number,
  },
  data() {
    return {
      // 是否显示固定
      layout: {
        visaFormName: '',
      },
    };
  },
  computed: {
    // 推荐列表
    recommendProductList() {
      return this.productList.filter(product => product.is_recommended);
    },
    // 非推荐列表
    needFilterProductList() {
      return this.productList.filter(product => !product.is_recommended);
    },

    showProductList() {
      if (this.entryCountType === 0) {
        return this.needFilterProductList;
      } else if (this.entryCountType === 1) {
        return this.needFilterProductList.filter(item => item.entry_count_unit === 0 && item.entry_count_n === 1);
      } else if (this.entryCountType === 2) {
        return this.needFilterProductList.filter(item => item.entry_count_unit !== 0 || item.entry_count_n !== 1);
      }
      return [];
    },
    // 根据签证类型分类
    categoryProductObj() {
      // 根据类型分类
      const categoryProductObj = {};
      this.showProductList.forEach((product) => {
        if (!categoryProductObj[product.visa_form]) {
          categoryProductObj[product.visa_form] = [];
        }
        categoryProductObj[product.visa_form].push(product);
      });
      return categoryProductObj;
    },
    // 是否需要显示签证类型分类
    showVisaTypeCategoryName() {
      if (!this.categoryProductObj) return false;
      // 没有筛选任何条件下
      const defaultFilter = !this.entryCountType;
      // 只有一个分类名称
      const categoryLength = Object.keys(this.categoryProductObj).length;
      return defaultFilter && categoryLength > 1;
    },

    // 固定的筛选框高度
    filterHeight() {
      return 60 + 50;
    },
    // 固定的header高度
    headerFixedHeight() {
      return 84;
    },

    // 获取当前数据类型
    visaTypeName() {
      if (!this.productList || !this.productList.length) return '';
      return this.productList[0].visa_type;
    },

  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {

      this.setVisaTypeCategoryName();
    },
    setVisaTypeCategoryName() {
      // 判断是否需要显示标签
      if (!this.showVisaTypeCategoryName) {
        this.layout.visaFormName = '';
        return;
      }

      this.$nextTick(() => {
        const pageScrollTop = utils.getPageScrollTop(); // 滚动距离
        const height = this.headerFixedHeight + this.filterHeight + pageScrollTop;

        // 遍历获取查找当前的类别
        const currentCategory = this.$refs.categoryProductList.find((category) => {
          const startHeight = category.offsetTop;
          const endHeight = category.offsetHeight + category.offsetTop;
          return height > startHeight && height <= endHeight;
        });
        // 没有在当前类型，清空
        if (!currentCategory) {
          this.layout.visaFormName = '';
          return; 
        }
        if (currentCategory.getAttribute('name') === this.layout.visaFormName) return;
        this.layout.visaFormName = currentCategory.getAttribute('name') || '';
      });

    },

  },
};
</script>

<style scoped lang="less">
.product-list-box{
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
  border-radius: 2px;

  .fixed-visa-form-name {
    position: fixed;
    top: 278px;
    width: 1120px;
    padding: 14px 0 14px 20px;
    height: 42px;
    font-size: 14px;
    color: #6F6F6F;
    line-height: 14px;
    font-weight: 600;
    background-color: #F3F6F9;
    z-index: 4;
  }

  .recommend-product-list {
    margin-top: 12px;
    // background: #F5F9FF;
    // background: linear-gradient(to right,#FAFCFF 0%,#F2F7FF 100%);
    background-color: #fff;
    border-radius: 2px;
    .recommed-title {
      font-size: 14px;
      color: #444444;
      line-height: 14px;
      padding: 14px 0;
      display: flex;
      align-items: center;
      font-weight: 600;
      border-bottom: 1px solid #E9EEF2;
      &::before {
        content: '';
        width: 4px;
        height: 18px;
        background: #599FFF;
        border-radius: 1px;
        margin-right: 8px;
      }
      .text {
        &::before, &::after {
          content: '';
          display: inline-block;
          width: 8px;
          height: 14px;
        }
        &::before {
          content: '';
          margin-right: 2px;
          background: url(../../../assets/imgs/country/wheat-left.png) no-repeat center;
          background-size: 100% 100%;
        }
        &::after {
          content: '';
          margin-left: 2px;
          background: url(../../../assets/imgs/country/wheat-right.png) no-repeat center;
          background-size: 100% 100%;
        }
      }
    }

    .product-item{
      // background: linear-gradient(to right,#FAFCFF 0%,#F2F7FF 100%);
      border-bottom: 1px solid #E9EEF2;
    }

  }

  .category-product-list {
    .category-title {
      padding: 14px 0 14px 20px;
      font-size: 14px;
      color: #6F6F6F;
      line-height: 14px;
      font-weight: 600;
      background-color: #F3F6F9;
    }
  }

  .product-list {
    &.m-t-12 {
      margin-top: 24px;
    }
  }

  .nodata{
    width: 100%;
    height: 443px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 74px;
    .nodata-img{
      width: 200px;
      height: 132px;
    }
    .nodata-text{
      margin-top: 16px;
      font-size: 16px;
      color: #91999F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/product-list.vue